import { removeIllegalChars } from '@fora-monorepo/string-utils';
import { trackException } from '@fora-monorepo/webapp-analytics';

export const formatFileName = ({
  employerName,
  organizationNumber,
  fileType,
  createdDate,
}: {
  employerName?: string;
  organizationNumber?: string;
  fileType: 'report-details' | 'deviation-report' | 'information-report';
  createdDate?: string;
}) => {
  if (!createdDate) {
    const message = `createdDate is missing in file name`;
    trackException(new Error(message));
  }

  if (employerName && organizationNumber) {
    if (fileType === 'deviation-report') {
      return `${removeIllegalChars(employerName)} (${organizationNumber}) - Avvikelserapport_${formatDate(createdDate)}.csv`;
    } else if (fileType === 'report-details') {
      return `${removeIllegalChars(employerName)} (${organizationNumber}) - Detaljer för inrapporterade löner_${formatDate(createdDate)}.csv`;
    } else {
      // information report
      return `${removeIllegalChars(employerName)} (${organizationNumber}) - Informationsrapport_${formatDate(createdDate)}.csv`;
    }
  }

  const message = `file name is empty for ${fileType} file, org: ${employerName} orgNo: ${organizationNumber} createdDate: ${createdDate}`;
  trackException(new Error(message));
  return 'document.csv';
};

const formatDate = (dateString?: string): string => {
  return dateString ? dateString.replace(/-/gi, '').slice(0, 8) : '';
};
